export const CLAIM_ORDER = "CLAIM_ORDER";
export const REMOVE_ACTIVE_ORDER = "REMOVE_ACTIVE_ORDER";
export const SET_ACTIVE_ORDER = "SET_ACTIVE_ORDER";
export const SET_QB_TOKEN = "SET_QB_TOKEN";
export const SET_CANT_FULFILL = "SET_CANT_FULFILL";
export const SET_IMAGE = "SET_IMAGE";
export const SYNC_ORDER_TO_DB = "SYNC_ORDER_TO_DB";
export const TOGGLE_DELIVERY_PICKEDUP = "TOGGLE_DELIVERY_PICKEDUP";
export const TOGGLE_FULFILLMENT = "TOGGLE_FULFILLMENT";
export const UPDATE_ADMIN_CONTROLS = "UPDATE_ADMIN_CONTROLS";
export const UPDATE_EMAIL_CAMPAIGNS = "UPDATE_EMAIL_CAMPAIGNS";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const UPDATE_ORDER_PAYMENT_OBJECT = "UPDATE_ORDER_PAYMENT_OBJECT";
export const SET_MANUAL_DELIVERY = "SET_MANUAL_DELIVERY";
export const UPDATE_PICKUP_DATE = "UPDATE_PICKUP_DATE";
export const UPDATE_TRACKING_CODE = "UPDATE_TRACKING_CODE";
export const UPDATE_LEAD_TIME = "UPDATE_LEAD_TIME";



// WEBPACK FOOTER //
// ./src/components/orders-v2/actions/types.js